import script from "./contracting-party-and-policies-step.vue?vue&type=script&setup=true&lang=js"
export * from "./contracting-party-and-policies-step.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__